import { Link } from "react-router-dom";
import { Avatar, InstitutionMark, VerifiedBadge } from "@/components/Brand";

export function UserChip({ u, size = 44, right = null, onClick }) {
  const inst = u.role === "institution";
  return (
    <div className="flex items-center gap-3 rounded-2xl p-2 transition-colors hover:bg-white/5" data-testid={`user-chip-${u.id}`}>
      <Link to={`/perfil/${u.id}`} onClick={onClick} className="flex min-w-0 flex-1 items-center gap-3">
        {inst ? <InstitutionMark name={u.name} logo={u.avatar} color={u.brand_color} size={size} /> : <Avatar name={u.name} src={u.avatar} size={size} />}
        <div className="min-w-0">
          <p className="flex items-center gap-1.5 truncate text-sm font-bold">{u.name}{u.verified && <VerifiedBadge size={14} />}</p>
          <p className="text-xs text-muted-foreground">{inst ? (u.verified ? "Instituição verificada" : "Instituição") : "Usuário"}</p>
        </div>
      </Link>
      {right}
    </div>
  );
}
